import type {
    DinoAssistantState
} from "../../assets/dino-assistant/dinoAssistantAssets.js";

const stateByPage: Readonly<Record<string, DinoAssistantState>> = {
    home: "idle",
    grammar: "reading",
    vocabulary: "happy",
    travel: "surprised",
    journal: "reading",
    practice: "quiz",
    daily: "celebrating",
    profile: "happy",
    shop: "wink"
};

function getDinoSurfaceState(pageKind: string | undefined): DinoAssistantState | null {
    if (!pageKind) {
        return null;
    }

    return stateByPage[pageKind] ?? null;
}

export { getDinoSurfaceState };
